import { Document } from './Document'

class Isbn extends Document {
  #value
  #status

  constructor (ref, data) {
    super(ref)

    this.#value = data.value.trim()
    this.#status = data.status
  }

  get value () {
    const result = this.#status === 'pending'
      ? this.#maskValue()
      : this.#value
    return result.trim()
  }

  get status () {
    return this.#status
  }

  #maskValue () {
    const replacer = ''.padEnd(this.#value.length - 2, '*')
    return this.#value[0] + replacer + this.#value[this.#value.length - 1]
  }
}

export { Isbn }
